import { Injectable } from '@angular/core';
import { AuthHTTPService } from 'src/app/modules/auth/services/auth-http';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiRequestService } from 'src/app/service/api-request.service';

@Injectable({
  providedIn: 'root'
})
export class ClientListInfoService {
  // public clientDetails:any;
  public redirection_form:any = {};
  public complete_url:string = ""
  public terminate_url:string = ""
  public error_url:string = ""
  public over_quota_url:string = ""
  public accessRoles:any = {};
  public loginClientDetails:any = {};
  public switchUserAccess:boolean = false;
  public hasSetRedirectionData:boolean = false;
  public defaultSelectedUser:boolean = false;
  public ClientSelectedUser:boolean = false;
  public clientList:any=[];

  constructor(
    private authHttpService: AuthHTTPService,
    private router: Router,
    private http: HttpClient,
    private apiRequest: ApiRequestService,
  ) {
    this.accessRoles = JSON.parse(localStorage.getItem('access') || '');
    this.accessRoles = this.accessRoles.access_rules; 
    this.checkSwitchUserAccess();
    this.setClientDetails();
  }

  checkSwitchUserAccess(){
    if(this.accessRoles && this.accessRoles.header && this.accessRoles.header.switch_user){
      this.switchUserAccess = true;
    }
     
  }

  setClientDetails(){
    if(localStorage.getItem('clientDetails'))
    {
      this.loginClientDetails = localStorage.getItem('clientDetails');
      this.loginClientDetails = JSON.parse(this.loginClientDetails);
    }
  }

  getAllClients(){
    let opt = {};
    return this.apiRequest.request('GET',`/clients`,{},opt);
    // return this.http.get<any>(environment.apiUrl + `/quota/${survey_id}`,httpPostOptions);
  }

  setRedirectionValue(){
    // if(Object.keys(this.redirection_form).length > 0){
    //   this.complete_url = this.redirection_form.complete,  
    //   this.terminate_url =  this.redirection_form.terminate,  
    //   this.error_url = this.redirection_form.failure,
    //   this.over_quota_url = this.redirection_form.over_quota 
    // }
  }
}
